import React from 'react';
import { connect } from 'react-redux';
import { Actions as LEGAL_ACTIONS } from '../../store/actions/legalActions';
import {
  selectUserOutstanding,
  selectCatalogueItems,
  selectIsUpdatedDoc,
  selectGraceDaysRemaining,
} from '../../store/selectors/legalSelectors';
import AgreementsModal from './AgreementsModal';

const UserAgreementsModal = ({
  branding,
  wlSettings,
  outstandingDocs,
  catalogueItems,
  markdownCache,
  loading,
  fetchLegalMarkdown,
  acceptLegalDocuments,
  updatedDocInfo,
  dismissable,
  onDismiss,
}) => (
  <AgreementsModal
    scope='user'
    outstandingDocs={outstandingDocs}
    catalogueItems={catalogueItems}
    markdownCache={markdownCache}
    loading={loading}
    updatedDocInfo={updatedDocInfo}
    wlSettings={wlSettings}
    branding={branding}
    dismissable={dismissable}
    onDismiss={onDismiss}
    fetchLegalMarkdown={fetchLegalMarkdown}
    acceptLegalDocuments={acceptLegalDocuments}
  />
);

const mapDispatchToProps = (dispatch) => ({
  fetchLegalMarkdown: (kind, version) => dispatch(LEGAL_ACTIONS.fetchLegalMarkdown(kind, version)),
  acceptLegalDocuments: (documents) => dispatch(LEGAL_ACTIONS.acceptLegalDocuments(documents)),
});

const mapStateToProps = (state) => {
  const outstandingDocs = selectUserOutstanding(state);
  const catItems = selectCatalogueItems(state);

  const updatedDocInfo = outstandingDocs
    .filter((doc) => selectIsUpdatedDoc(state, doc.documentKind))
    .map((doc) => {
      const item = catItems.find((i) => i.documentKind === doc.documentKind);
      return {
        documentKind: doc.documentKind,
        title: item?.title || doc.documentKind,
        graceDays: selectGraceDaysRemaining(state, doc.documentKind),
      };
    });

  return {
    wlSettings: state.whiteLabelAdmin,
    branding: state.branding,
    outstandingDocs,
    catalogueItems: catItems,
    markdownCache: state.legal?.markdownCache || {},
    loading: state.legal?.loading || {},
    updatedDocInfo,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAgreementsModal);
